module.exports = __webpack_public_path__ + "./static/img/icondis-4.d2591cd69d6203e9e1e9cc1d8ab2cceb.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/company/icondis-4.png
// module id = ./client/src/assets/img/company/icondis-4.png
// module chunks = 0